// extracted by mini-css-extract-plugin
export default {"main":"MainContent_main__M4HSc","container":"MainContent_container__ZOESc"};